import React from 'react'
import { Button, Tag } from 'antd'
import { Link } from 'react-router-dom'
import moment from 'moment'
import _get from 'lodash/get'
import { FormattedMessage } from 'react-intl'
import { inject, observer } from 'mobx-react'
import { compose } from 'recompose'
import leftPad from 'left-pad'

const RegistrationItem = ({ registration, i18n: { locale } }) => {
  const {
    _id,
    event,
    expireAt,
    expired,
    // amount,
    participants,
    code,
    status,
    // successfulPayment,
    amount,
    // onSubmit,
    registrationType
  } = registration
  const hideNumber = _get(event, 'settings.ticket.hideNumber')
  // const { periods, isRegOpen } = event
  // const currentPeriod = periods.find(period =>
  //   moment().isBetween(period.start, period.end)
  // )
  // const canPay = isRegOpen && currentPeriod
  // const canSubmit = isRegOpen && currentPeriod && currentPeriod.preRegister // || (preRegisterPeriod && moment().isBetween(preRegisterPeriod.start, preRegisterPeriod.end))

  // const $submitButton = (
  //   <Button
  //     type="primary"
  //     size="large"
  //     onClick={() => onSubmit({ registrationId: _id })}
  //     style={{ marginLeft: '18px', float: 'right' }}
  //   >
  //     Submit
  //   </Button>
  // )
  // const $submitDisabledButton = (
  //   <Button
  //     type="primary"
  //     size="large"
  //     disabled
  //     style={{ marginLeft: '18px', float: 'right' }}
  //   >
  //     Submit
  //   </Button>
  // )
  // const $payButton = (
  //   <Link to={`/reg/${_id}/pay`} style={{ marginLeft: '18px', float: 'right' }}>
  //     <Button type="primary" size="large">PAY</Button>
  //   </Link>
  // )
  // const $expiredTag = (
  //   <Tag color="red" style={{ marginLeft: '18px', float: 'right' }}>
  //     Expired
  //   </Tag>
  // )
  // if (false) {
  //   const $actionButton = {
  //     draft: canSubmit ? $submitButton : $submitDisabledButton,
  //     submitted: canPay && (expired ? $expiredTag : $payButton)
  //   }
  //   console.log($actionButton)
  // }
  // $actionButton

  const $paymentStatus = ({
    paid: <Tag color="green">{_get(amount, 'discounted')} THB ({
      <FormattedMessage id="paymentStatus.paid" defaultMessag="Paid" />
    })</Tag>,
    payment_verifying: (
      <Tag color="yellow">{_get(amount, 'discounted')} THB ({
        <FormattedMessage id="paymentStatus.verifying" defaultMessag="Pending Verification" />
      })</Tag>
    ),
    '': <Tag color="orange">{_get(amount, 'discounted')} THB ({
      <FormattedMessage id="paymentStatus.pending" defaultMessag="Pending Payment" />
    })</Tag>
  })[status || '']
  return <div className="historyList" style={{ boxShadow: '0px 1px 4px gainsboro' }}>
    <div className="eventDetail">
      <div className="headerLine">
        <div>
          <span className="eventTitle" style={{ marginRight: '1em' }}>
            {code && <span className="registrationCode">[{code}]</span>}
            <Link to={`/events/${event.slug}`}>{event.name[locale]}</Link>
          </span>
        </div>
        <div>
          {_get(registrationType, ['name', locale])}
        </div>
        <span className="eventBottomDetailData">
          {$paymentStatus}
          {status === 'draft' && <Tag color="orange">
            <FormattedMessage id="registrationStatus.draft" defaultMessage="Pending Submission" />
          </Tag>}
          {participants.length === 0 && <Tag color="red">
            <FormattedMessage id="app.incomplete" defaultMessage="Incomplete" />
          </Tag>}
          {status !== 'paid' && expireAt &&
            (expired
              ? <Tag color="red">
                <FormattedMessage id="app.expired" defaultMessage="Expired" />
              </Tag>
              : <Tag color="orange">
                <FormattedMessage id="app.payBeforeDate" defaultMessage="Please pay before {date}" values={{
                  date: moment(expireAt).format('Do MMMM HH:mm')
                }} />
              </Tag>
            )
          }
        </span>
        {/* status */}
        {/* $actionButton[status] */}
      </div>
    </div>
    <div className="eventBottomDetail">
      <div className="eventBottomDetailTitle">Participants</div>
      <ul>
        {participants.map(participant => {
          const numbers = _get(participant, 'tickets', []).map(t => t.number).filter(n => n)
          return <li key={participant._id} >
            {participant.profile.firstName}{' '}
            {participant.profile.lastName} {!hideNumber && numbers.length > 0 && `[ BIB Number: ${numbers.map(number => leftPad(`${number}`, 4, '0')).join(', ')} ]`}
          </li>
        })}
      </ul>
    </div>
    <div style={{ textAlign: 'right' }}>
      <Link to={`/events/${event.slug}/register`} style={{ marginRight: 6 }}>
        <Button size="small">{
          {
            en: 'Register more',
            th: 'สมัครเพิ่ม'
          }[locale]
        }</Button>
      </Link>
      <Link to={`/reg/${_id}/preview`}>
        <Button size="small" type="primary">{
          {
            en: 'View',
            th: 'ดูใบสมัคร'
          }[locale]
        }</Button>
      </Link>
    </div>
  </div>
}

export default compose(
  inject('i18n'),
  observer
)(RegistrationItem)



// WEBPACK FOOTER //
// ./src/App/DashboardPage/Components/RegistrationItem.js